// extracted by mini-css-extract-plugin
module.exports = {"arrow":"cta_arrow__bIF7u","arrowCompact":"cta_arrowCompact__K4Yzd","container":"cta_container__y33GJ","sizeNormal":"cta_sizeNormal__F1Go3","sizeCompact":"cta_sizeCompact__8DzcO"};